import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import { format as formatTime } from 'my-phorest/utils/local-time-helpers';

export default class LocalTimeFormatHelper extends Helper {
  @service intl;

  compute([timeString, fmt = 'long', locale]) {
    if (!timeString) {
      return '';
    }

    let intl = this.intl;

    if (locale) {
      intl = { defaultLocale: locale };
    }

    return formatTime(timeString, intl, fmt);
  }
}
